import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../../components/sidebar";
import Header from "../../components/header";
import "../../assets/CSS/dashboard.css";
import "../../assets/CSS/forms.css";
import SubjectTable from "../../components/subjectTable";
import API_BASE_URL from "../../config";
import "../../assets/CSS/loader.css";
import { authFetch } from "../../utility/AuthFetch";

function Subject() {
  const navigate = useNavigate();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(0);
  const [subject, setSubject] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = editMode
      ? `${API_BASE_URL}/api/edit-subject-master`
      : `${API_BASE_URL}/api/subject-master`;

    if (editMode) {
      formData.append("ID", editId);
    }

    const method = editMode ? "PUT" : "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          editMode
            ? "Subject updated successfully"
            : "Subject added successfully"
        );
        formRef.current.reset();
        setIsSubmitting(false);
        setSubject("");
        setEditMode(false);
        setLoader(false);
        setEditId(null);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setSubject(item.subject);
    setEditMode(true);
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />
        <div id="form-content">
          <div id="form-header">
            <p>Subject Master</p>
          </div>
          <hr />
          <form id="form" ref={formRef}>
            <div id="form-input">
              <label htmlFor="subject">
                Subject<span className="required">*</span>
              </label>
              <input
                type="text"
                name="subject"
                id="subject"
                placeholder="Enter Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {editMode ? "UPDATE" : "SUBMIT"}
            </button>
          </div>
        </div>
        <SubjectTable reload={reload} onEdit={handleEdit} />
      </div>
    </div>
  );
}

export default Subject;
